import * as React from "react";
import { Context } from "./_context";
export const DataIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.996 5.516C7.614 5.503 4.5 8.738 4.5 12.5a7 7 0 0 0 7 7c3.762 0 6.997-3.114 6.984-6.496l2-.008c.018 4.617-4.246 8.504-8.984 8.504a9 9 0 0 1-9-9c0-4.738 3.887-9.002 8.504-8.984l-.008 2ZM14 2a8 8 0 0 1 8 8 1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V3l.005-.103A1 1 0 0 1 14 2Zm1 7h4.915A6.002 6.002 0 0 0 15 4.084V9Z", fill: "currentColor" }));
  return iconset[size];
};
DataIcon.iconId = "7IlAJw";
